import { WS_NOTIFICATION_KINDS, type WsNotificationKind } from 'cpool-constants';

import { type QueryKey, queryKeys } from '~/utils/queryKeys';

// bell query per push kind - its resolver gates `position` on the table the kind's events write
export const NOTIFICATION_QUERY_KEY_BY_KIND: Record<WsNotificationKind, QueryKey> = {
    [WS_NOTIFICATION_KINDS.ACTIVE_USER_SET]: queryKeys.getActiveUserSetLeads(),
    [WS_NOTIFICATION_KINDS.ASSIGNED_USER_ADDED]: queryKeys.getAddedAssignedUserLeads(),
    [WS_NOTIFICATION_KINDS.BANK_REPORT]: queryKeys.getUnreadConsorsNotes(),
    [WS_NOTIFICATION_KINDS.DOCUMENT]: queryKeys.getLoanRequestsWithUnverifiedDocuments(),
    [WS_NOTIFICATION_KINDS.PROCESSED]: queryKeys.getProcessedNotifications(),
    [WS_NOTIFICATION_KINDS.RESUBMISSION]: queryKeys.getResubmissionLoanRequestsByDate(),
};

// further affected queries gated on a table the kind's events don't write - refetched without position
export const NOTIFICATION_DEPENDENT_QUERY_KEYS_BY_KIND: Partial<Record<WsNotificationKind, Array<QueryKey>>> = {
    // may read ProcessedNotifications before it's written - only other tabs, they catch up on the next refetch
    [WS_NOTIFICATION_KINDS.PROCESSED]: [queryKeys.getAddedAssignedUserLeads(), queryKeys.getActiveUserSetLeads()],
};

// resynced on socket (re)connect and every NOTIFICATIONS_FALLBACK_RESYNC_INTERVAL_MS
export const ALL_NOTIFICATION_QUERY_KEYS: Array<QueryKey> = Object.values(NOTIFICATION_QUERY_KEY_BY_KIND);

// safety net: lost pushes (pub/sub doesn't redeliver) + items no push reaches (bank reports, non-restricted roles)
export const NOTIFICATIONS_FALLBACK_RESYNC_INTERVAL_MS = 5 * 60_000;
